import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import makeArray from 'webapp/helpers/make-array';
import visibleCheckContainer from 'webapp/modifiers/visible-check-container';
import MetricLibraryGridComponent from 'webapp/components/metric-library/grid/index';
import MetricLibrarySourceGridItemComponent from 'webapp/components/metric-library/source/grid-item';

import FilterSortMetricLibraryMainIntegrations from 'webapp/models-custom/filter-sort/metric-library-main-integrations';

interface Args {
	showConnectedIntegrationsSection: boolean;
}

export default class MetricLibraryPopularIntegrationsComponent extends Component<Args> {
	@service('model-manager/source-types')
	declare mmSourceTypesService: Service.ModelManager.SourceTypes;

	filterSort;
	@tracked initialRowCount = 5;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.filterSort = new FilterSortMetricLibraryMainIntegrations({
			getAllItems: () => {
				return this.integrations;
			},
		});
	}

	@cached
	get integrations() {
		return this.mmSourceTypesService.connectableSourceTypeModels
			.filter((st) => !st.isGroup && !st.isHidden && !st.isAlreadyConnected)
			.sort((a, b) => a.popularity - b.popularity);
	}

	get title() {
		return this.args.showConnectedIntegrationsSection
			? 'Other popular integrations'
			: 'Popular integrations';
	}

	@action
	updateMinDisplayedRows(n: number): void {
		this.initialRowCount = Math.max(Math.ceil(15 / n), 5);
	}
	<template>
		<MetricLibraryGridComponent
			@filterSort={{this.filterSort}}
			@title={{this.title}}
			@classNames="popular-integrations"
			@initialRowCount={{this.initialRowCount}}
			@onItemsPerRowCalculated={{this.updateMinDisplayedRows}}
			@animationProperty="id"
			@hideCountBadge={{true}}
			as |visibleItems settings|
		>
			<ul class="flex-ct flex-ct--size-source" {{visibleCheckContainer}}>
				{{#each visibleItems as |model|}}
					<MetricLibrarySourceGridItemComponent @model={{model}} />
				{{/each}}

				{{! adding (max-in-line - 1) fake items so the incomplete last row items are not stretched too much }}
				{{#each (makeArray length=settings.itemsPerRow)}}
					<li class="flex-item flex-item--fake"></li>
				{{/each}}
			</ul>
		</MetricLibraryGridComponent>
	</template>
}
